export const mapFacilityTypes = (
  selectedIds: number[],
  existingFacilityTypes: any[],
) => {
  return selectedIds.map((facilityTypeId) => {
    const existing = existingFacilityTypes?.find(
      (f) => f.facilityTypeId === facilityTypeId,
    );

    return {
      id: existing ? existing?.id : 0,
      entityId: existing ? existing?.entityId : 0,
      facilityTypeId,
    };
  });
};

export const mapRecordTypes = (
  selectedIds: number[],
  existingRecordType: any[],
) => {
  return selectedIds.map((recordTypeId) => {
    const existing = existingRecordType?.find(
      (f) => f.recordTypeId === recordTypeId,
    );

    return {
      id: existing ? existing?.id : 0,
      recordTypeId,
    };
  });
};

export const mapFollowUpMethods = (
  selectedIds: number[],
  existingFollowUpMethods: any[],
) => {
  return selectedIds.map((followUpMethodId) => {
    const existing = existingFollowUpMethods?.find(
      (f) => f.followUpMethodId === followUpMethodId,
    );

    return {
      id: existing ? existing?.id : 0,
      followUpMethodId,
    };
  });
};




